import { cn } from "@/utils/tailwind-helper";
import { component$ } from "@builder.io/qwik";

export const PageSearchResultItemSkeleton = component$(() => {
    return (
        <div class={cn("flex items-center justify-between gap-6 rounded bg-white/80")}>
            {/* Image skeleton */}
            <div class={cn("h-[84px] w-[128px] bg-primary-500/10", "animate-pulse")} />
            {/* Text skeletons */}
            <div class={cn("mr-auto flex w-[22.84%] flex-col items-start gap-1", "animate-pulse")}>
                <div class="h-6 w-full min-w-[100px] rounded-md bg-primary-500/10" />
                <div class="h-4 w-[26.96%] min-w-10 rounded-md bg-primary-500/10" />
            </div>
            {/* Chevron skeleton */}
            <div class={cn("mr-6 h-6 w-6 rounded-md bg-primary-500/10", "animate-pulse")}></div>
        </div>
    );
});
